import React, { FC, useState } from "react";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";
import useTheme from "evcharging/hooks/useTheme";
import { Utility } from "services/delivery/types";
import { isShortZipCodeOnType } from "utils/form/asserts";
import Responsible from "evcharging/components/Responsible";
import RatesInput from "containers/retail/sections/energy-rates-3/RatesInput";
import RatesSelect from "containers/retail/sections/energy-rates-3/RatesSelect";
import useI18n from "evcharging/hooks/useI18n";
import { CustomerType } from "../../../../services/orders/types";

interface RatesProps {
  utilities: Utility[];
  zipCode: string;
  utilityId?: string;
  customerType: CustomerType;
  onChangeZipCode: (zipCode: string) => void;
  onChangeUtilityId: (utilityId: string) => void;
  onChangeCustomerType: (customerType: CustomerType) => void;
}

const RatesFilter: FC<RatesProps> = (props) => {
  const { utilities, zipCode, utilityId = '', customerType,  onChangeZipCode, onChangeUtilityId, onChangeCustomerType } = props;

  const { t } = useI18n();

  const [zip, setZip] = useState<string>(zipCode);

  const handleZipCode = (value: string) => {
    if (value.length > 5 || !isShortZipCodeOnType(value)) {
      return;
    }

    setZip(value);

    if (value.length === 5) {
      onChangeZipCode(value);
    }
  };

  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <div className={styles.root}>
      <Responsible fractions={[33, 33, 33]} space={24}>
        <RatesInput
          label={t('form.label.zipCode')}
          placeholder={'12345'}
          value={zip}
          onChange={handleZipCode}
        />
        <RatesSelect
          label={t('utility')}
          placeholder={t('none')}
          value={utilityId}
          onChange={onChangeUtilityId}
          options={utilities.map((utility) => ({
            value: utility.utilityId,
            label: utility.name,
          }))}
        />
        <RatesSelect
          label={t('customer-type')}
          placeholder={t('none')}
          value={customerType}
          onChange={onChangeCustomerType}
          options={[
            {value: CustomerType.RESIDENTIAL, label: t(CustomerType.RESIDENTIAL.toLowerCase())},
            {value: CustomerType.COMMERCIAL, label: t(CustomerType.COMMERCIAL.toLowerCase())},
          ]}
        />
      </Responsible>
    </div>
  );
};

const createStyles = (theme: Theme) => (
  {
    root: css`
      margin-top: 16px;
      ${theme.breakpoints.mobile.up} {
        border: 1px solid #D3D5DC;
        border-radius: 6px;
        margin-top: 0;
        padding: 16px;
      }
    `,
  }
);

export default RatesFilter;
